import store from '../../store/store';
import { ConfigModule } from '/@/store/enums';

const ApiResponseError = (error: any) => {
	store.commit(ConfigModule.SET_LOADING, false);

	return Promise.reject(error);
};

export default ApiResponseError;
